<template>
  <Popper class="relative inline-block" placement="bottom-start" hover>
    <button type="button" class="text-gray-400 hover:text-amber-500 focus:outline-none">
      <svg xmlns="http://www.w3.org/2000/svg" :class="iconClass" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" />
      </svg>
      
    </button>
    <template #content>
      <div :class="width" class="mt-2 text-sm bg-gray-100 dark:bg-slate-700 text-gray-800 dark:text-gray-100 p-3 rounded border border-gray-300 dark:border-gray-600 shadow-md" v-html="details">
       
      </div>
    </template>
  </Popper>
</template>
<script setup lang="ts">
import Popper from "vue3-popper";
const props = defineProps({
  details: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    default: 'w-72',
  },
  iconClass:{
    type: String,
    default: 'h-4 w-4',
  }
})
</script>
